import { createFileRoute, redirect } from '@tanstack/react-router';
import { useRealmAuthStore as realmAuthStore } from '@interxfi/api-client';
import { FrameLoadingTrigger } from '@interxfi/design-system/components/frame/context';
import { DEFAULT_AUTHENTICATED_ROUTE, DEFAULT_UNAUTHENTICATED_ROUTE } from '../util/routing/defaults';

async function handleRootRedirect(maxWait: number = 15000, interval: number = 50) {
  return new Promise((_, reject) => {
    function rejectAndRedirect(isAuthenticated: boolean) {
      reject(redirect({ to: isAuthenticated ? DEFAULT_AUTHENTICATED_ROUTE : DEFAULT_UNAUTHENTICATED_ROUTE }));
    }

    if (!realmAuthStore.getState().isAuthenticating) {
      rejectAndRedirect(realmAuthStore.getState().isAuthenticated);
      return;
    }

    let runTime = 0;

    const i = window.setInterval(() => {
      runTime += interval;

      if (!realmAuthStore.getState().isAuthenticating) {
        clearInterval(i);
        rejectAndRedirect(realmAuthStore.getState().isAuthenticated);
        return;
      }

      if (runTime > maxWait) {
        clearInterval(i);
        rejectAndRedirect(false);
      }
    }, interval);
  });
}

function Root() {
  return <FrameLoadingTrigger />;
}

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    await handleRootRedirect();
  },
  component: Root,
});
